import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { addPvNew } from '../../../utils';
import { mapGetters } from 'vuex';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
export default {
  name: 'poiOldFriend',
  props: {
    adsInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  mounted() {
    // 展现埋点
    this.showHandle();
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['is_dark'])), {}, {
    iconDark() {
      const {
        pic_url = ''
      } = this.adsInfo;
      const themedUrl = pic_url.replace('/default/', this.is_dark ? '/dark/' : '/default/');
      return themedUrl;
    }
  }),
  methods: {
    showHandle() {
      /**
       * 广告展示埋点
       */
      this.$nextTick(() => {
        const commentRef = this.$refs.friend;
        commentRef && this.$io.observe(commentRef, () => {
          const {
            ext: {
              adid = '',
              isad = ''
            } = {}
          } = this.adsInfo || {};
          addPvNew(['MCDnhp.shelf.PGshow'], {
            Feed_id: this.unique_id,
            adid,
            isad
          });
        });
      });
    },
    jumpUrl(url, index) {
      const {
        ext: {
          adid = '',
          isad = ''
        } = {}
      } = this.adsInfo || {};
      if (index === 1) {
        addPvNew(['MCDnhp.shelf.click'], {
          Feed_id: this.unique_id,
          adid,
          isad
        });
      } else {
        addPvNew(['MCDnhp.shelfRoutebutton.click'], {
          Feed_id: this.unique_id,
          adid,
          isad
        });
      }
      openUrlByOpenApi(url);
    }
  }
};